<script lang="ts" setup>
</script>

<template>
  <div>
    <SiteHeader/>
    <slot/>
    <SiteFooter/>
  </div>
</template>

<style scoped>

</style>